import React, { useEffect, useState }                       from 'react';
import { Button, Col, Form, Row }                           from 'react-bootstrap';
import { useSelector }                                      from 'react-redux';
import fileDownload                                         from 'js-file-download';
import Swal                                                 from 'sweetalert2';
import moment                                               from 'moment';

import ButtonSpinner                                        from '../layout/ButtonSpinner';
import { MSG_ERROR_SERVER }                                 from '../../constants/messages';
import { ErrorMessage, WaitingMessage }                     from '../extras/toastMessages';
import { ICON_DOWNLOAD, ICON_UNDO }                         from '../extras/icons';

import clienteAxios                                         from '../../config/axios';
import axiosReport                                          from '../../config/axiosReport';

import audienceStates                                       from '../../data/audienceStates';
import { PROFILE_FISCAL, PROFILE_OGA, PROFILE_SISTEMAS }    from '../../data/profiles';





const ReportForm = () => {



    // ------------------------------------------------------------------------------------------------------
    // DECLARACIONES ----------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    // Iincializo la data
    const initialData = {
        fechaSolicitudDesde: '',
        fechaSolicitudHasta: '',
        fechaInicioDesde: '',
        fechaInicioHasta: '',
        numero: '',
        caratula: '',
        tipo: '',
        estado: '',
        sala: '',
        prioridad: '',
        solicitante: '',
        juez: ''
    }

    // Traigo el store
    const authUser = useSelector(state => state.auth.user);

    //Inicializo el state local    
    const [ audienceTypes, setAudienceTypes ] = useState([]);
    const [ filter, setFilter ] = useState(initialData);
    const [ judges, setJudges ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ rooms, setRooms ] = useState([]);
    const [ units, setUnits ] = useState([]);



    // ------------------------------------------------------------------------------------------------------
    // FUNCIONES --------------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    // Manejo eventos
    useEffect(() => {
        //Cargo los parámetros
        loadParameters();
    }, []);

    // Manejo de cambios
    const handleChange = e => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        })
    }

    // Cargo los parámetros de búsqueda
    const loadParameters = async () => {
        try
        {   //Seteo la espera
            setLoading(true);
            //Tipos
            const responseAudienceTypes = await clienteAxios.get(`/audiencia-tipo?search=activo:1&sort=descripcion:asc`);
            setAudienceTypes(responseAudienceTypes.data.content);
            //Salas
            const responseRooms = await clienteAxios.get(`/sala?search=activo:1&sort=descripcion:asc`);
            setRooms(responseRooms.data.content);
            //Jueces
            const responseJudges = await clienteAxios.get(`/juez?search=activo:1&sort=apellido:asc,nombre:asc`);
            setJudges(responseJudges.data.content);
            //Solicitantes
            const responseUnits = await clienteAxios.get(`/unidad?search=activo:1,perfil.id>1&sort=descripcion:asc`);
            setUnits(responseUnits.data.content);
            //Oculto la espera
            setLoading(false);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
            //Oculto la espera
            setLoading(false);
        }
    }

    // Manejo la búsqueda
    const handleSubmit = async e => {
        e.preventDefault();
        //Parámetros iniciales
        let params = {
            sort: 'inicio:asc,id:asc'
        }
        //Inicializo ruta
        let method = 'reporte-oga';
        //Si es perfil fiscal
        if(authUser.perfil.id === PROFILE_FISCAL)
        {   method = 'reporte-mpf';
        }
        //Cargo la espera
        WaitingMessage('Generando reporte');
        setLoading(true);

        //Estado
        if(filter.estado && filter.estado.trim() !== '')
        {   params = {
                ...params,
                search: `estado.id:${filter.estado}`
            }
        }
        //Fecha Solicitud
        if(filter.fechaSolicitudDesde && filter.fechaSolicitudDesde !== '' && filter.fechaSolicitudHasta && filter.fechaSolicitudHasta !== '')
        {   params = {
                ...params,
                search: params.search && params.search !== '' ? `${params.search},fechaSolicitud:${filter.fechaSolicitudDesde}/${filter.fechaSolicitudHasta}` : `fechaSolicitud:${filter.fechaSolicitudDesde}/${filter.fechaSolicitudHasta}`
            }
        }
        else
        {   //Fecha Solicitud desde
            if(filter.fechaSolicitudDesde && filter.fechaSolicitudDesde !== '')
            {   params = {
                    ...params,
                    search: params.search && params.search !== '' ? `${params.search},fechaSolicitud>${filter.fechaSolicitudDesde}` : `fechaSolicitud>${filter.fechaSolicitudDesde}`
                }
            }
            //Fecha Solicitud hasta
            if(filter.fechaSolicitudHasta && filter.fechaSolicitudHasta !== '')
            {   params = {
                    ...params,
                    search: params.search && params.search !== '' ? `${params.search},fechaSolicitud<${filter.fechaSolicitudHasta}` : `fechaSolicitud<${filter.fechaSolicitudHasta}`
                }
            }
        }
        //Fecha Inicio
        if(filter.fechaInicioDesde && filter.fechaInicioDesde !== '' && filter.fechaInicioHasta && filter.fechaInicioHasta !== '')
        {   params = {
                ...params,
                search: params.search && params.search !== '' ? `${params.search},fechaInicio:${filter.fechaInicioDesde}/${filter.fechaInicioHasta}` : `fechaInicio:${filter.fechaInicioDesde}/${filter.fechaInicioHasta}`
            }
        }
        else
        {   //Fecha Inicio desde
            if(filter.fechaInicioDesde && filter.fechaInicioDesde !== '')
            {   params = {
                    ...params,
                    search: params.search && params.search !== '' ? `${params.search},fechaInicio>${filter.fechaInicioDesde}` : `fechaInicio>${filter.fechaInicioDesde}`
                }
            }
            //Fecha Inicio hasta
            if(filter.fechaInicioHasta && filter.fechaInicioHasta !== '')
            {   params = {
                    ...params,
                    search: params.search && params.search !== '' ? `${params.search},fechaInicio<${filter.fechaInicioHasta}` : `fechaInicio<${filter.fechaInicioHasta}`
                }
            }
        }
        //Numero
        if(filter.numero && filter.numero !== '')
        {   params = {
                ...params,
                search: params.search && params.search !== '' ? `${params.search},expediente.numero:${filter.numero}` : `expediente.numero:${filter.numero}`
            }
        }
        //Carátula
        if(filter.caratula && filter.caratula !== '')
        {   params = {
                ...params,
                search: params.search && params.search !== '' ? `${params.search},expediente.caratula:${encodeURIComponent(filter.caratula)}` : `expediente.caratula:${encodeURIComponent(filter.caratula)}`
            }
        }
        //Solicitante
        if(filter.solicitante && filter.solicitante.trim() !== '')
        {   params = {
                ...params,
                search: params.search && params.search !== '' ? `${params.search},solicitante.id:${filter.solicitante}` : `solicitante.id:${filter.solicitante}`
            }
        }
        //Sala
        if(filter.sala && filter.sala.trim() !== '')
        {   params = {
                ...params,
                search: params.search && params.search !== '' ? `${params.search},sala.id:${filter.sala}` : `sala.id:${filter.sala}`
            }
        }
        //Juez
        if(filter.juez && filter.juez.trim() !== '')
        {   params = {
                ...params,
                search: params.search && params.search !== '' ? `${params.search},juez:${filter.juez}` : `juez:${filter.juez}`
            }
        }
        //Tipo
        if(filter.tipo && filter.tipo.trim() !== '')
        {   params = {
                ...params,
                search: params.search && params.search !== '' ? `${params.search},tipo:${filter.tipo}` : `tipo:${filter.tipo}`
            }
        }
        //Ejecuto la consulta
        try
        {   //Hago la consulta
            const response = await axiosReport.get(`/excel/${method}`, { params });
            //Oculto la espera
            Swal.close();
            //Genero el nombre del archivo
            let fileName = moment().format('YYYYMMDDHHmmss');
            fileName = `OGA-${fileName}.xlsx`;
            //Descargo el archivo
            fileDownload(response.data, fileName);
            setLoading(false);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
            setLoading(false);
        }
    }

    // Reseteo los filtros
    const handleReset = e => {
        e.preventDefault();
        setFilter(initialData);
    }
    




    // ------------------------------------------------------------------------------------------------------
    // RENDERIZO --------------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    return (
        <React.Fragment>
            <Row>
                <Col xs="12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 className="m-0 font-weight-bold text-primary">Parámetros de búsqueda</h6>
                        </div>
                        <div className="card-body">
                            <Form onSubmit={handleSubmit} autoComplete="off">
                                <Row>
                                    <Form.Group className="col-md-3">
                                        <Form.Label>Fecha Solicitud Desde:</Form.Label>
                                        <Form.Control
                                            id = "fechaSolicitudDesde"
                                            className = "form-control" 
                                            autoFocus 
                                            name = "fechaSolicitudDesde" 
                                            type = "date" 
                                            placeholder = "Fecha Solicitud Desde"
                                            value = { filter.fechaSolicitudDesde }
                                            onChange = { handleChange }
                                            disabled = { loading }
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-md-3">
                                        <Form.Label>Fecha Solicitud Hasta:</Form.Label>
                                        <Form.Control
                                            id = "fechaSolicitudHasta"
                                            className = "form-control" 
                                            name = "fechaSolicitudHasta" 
                                            type = "date" 
                                            placeholder = "Fecha Solicitud Hasta"
                                            value = { filter.fechaSolicitudHasta }
                                            onChange = { handleChange }
                                            disabled = { loading }
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-md-3">
                                        <Form.Label>Fecha Inicio Desde:</Form.Label>
                                        <Form.Control
                                            id = "fechaInicioDesde"
                                            className = "form-control" 
                                            name = "fechaInicioDesde" 
                                            type = "date" 
                                            placeholder = "Fecha Inicio Desde"
                                            value = { filter.fechaInicioDesde }
                                            onChange = { handleChange }
                                            disabled = { loading }
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-md-3">
                                        <Form.Label>Fecha Inicio Hasta:</Form.Label>
                                        <Form.Control
                                            id = "fechaInicioHasta"
                                            className = "form-control" 
                                            name = "fechaInicioHasta" 
                                            type = "date" 
                                            placeholder = "Fecha Inicio Hasta"
                                            value = { filter.fechaInicioHasta }
                                            onChange = { handleChange }
                                            disabled = { loading }
                                        />
                                    </Form.Group>
                                    <Col md="2" className="form-group">
                                        <input 
                                            type = "text"
                                            className = "form-control"
                                            placeholder = "Nro. Legajo"
                                            name = "numero"
                                            value = { filter.numero }
                                            onChange = { handleChange }
                                            disabled = { loading }
                                        />
                                    </Col>
                                    <Col md="6" className="form-group">
                                        <input 
                                            type = "text"
                                            className = "form-control"
                                            placeholder = "Carátula"
                                            name = "caratula"
                                            value = { filter.caratula }
                                            onChange = { handleChange }
                                            disabled = { loading }
                                        />
                                    </Col>

                                    {   authUser && (authUser.perfil.id===PROFILE_SISTEMAS || authUser.perfil.id===PROFILE_OGA) 
                                            ?
                                                <Col md="4" className="form-group">
                                                    <select 
                                                        className = "form-control"
                                                        name = "estado"
                                                        value = { filter.estado }
                                                        onChange = { handleChange }
                                                        disabled = { loading }
                                                    >
                                                        <option value="">Todos los Estados</option>
                                                        {   audienceStates.map(audienceState => (
                                                                <option value={audienceState.id} key={`fmas${audienceState.id}`}>
                                                                    { audienceState.descripcion }
                                                                </option>
                                                            ))
                                                        }
                                                    </select>
                                                </Col>
                                            : 
                                                null
                                    }
                                    
                                    <Col md="6" className="form-group">
                                        <select 
                                            className = "form-control"
                                            name = "tipo"
                                            value = { filter.tipo }
                                            onChange = { handleChange }
                                            disabled = { loading }
                                        >
                                            <option value="">Todos los Tipos de Audiencia</option>
                                            {   audienceTypes.map(audienceType => (
                                                    <option value={audienceType.id} key={`fmat${audienceType.id}`}>
                                                        { audienceType.descripcion }
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </Col>
                                    <Col md="3" className="form-group">
                                        <select 
                                            className = "form-control"
                                            name = "sala"
                                            value = { filter.sala }
                                            onChange = { handleChange }
                                            disabled = { loading }
                                        >
                                            <option value="">Todas las Salas</option>
                                            {   rooms.map(room => (
                                                    <option value={room.id} key={`fms${room.id}`}>
                                                        { room.descripcion }
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </Col>

                                    {   authUser && (authUser.perfil.id===PROFILE_SISTEMAS || authUser.perfil.id===PROFILE_OGA) 
                                            ?
                                                <Col md="3" className="form-group">
                                                    <select 
                                                        className = "form-control"
                                                        name = "solicitante"
                                                        value = { filter.solicitante }
                                                        onChange = { handleChange }
                                                        disabled = { loading }
                                                    >
                                                        <option value="">Todas los Solicitantes</option>
                                                        {   units.map(unit => (
                                                                <option value={unit.id} key={`fms${unit.id}`}>
                                                                    { unit.descripcion }
                                                                </option>
                                                            ))
                                                        }
                                                    </select>
                                                </Col>
                                            : 
                                                null
                                    }
                                    
                                    {   authUser && (authUser.perfil.id===PROFILE_SISTEMAS || authUser.perfil.id===PROFILE_OGA) 
                                            ? 
                                                <Col md="3" className="form-group">
                                                    <select 
                                                        className = "form-control"
                                                        name = "juez"
                                                        value = { filter.juez }
                                                        onChange = { handleChange }
                                                        disabled = { loading }
                                                    >
                                                        <option value="">Todos los Jueces</option>
                                                        {   judges.map(judge => (
                                                                <option value={judge.id} key={`fmj${judge.id}`}>
                                                                    { judge.apellido + ', ' + judge.nombre }
                                                                </option>
                                                            ))
                                                        }
                                                    </select>
                                                </Col>
                                            : 
                                                null
                                    }
                                    
                                    <Col md="2" lg="1" className="form-group">
                                        {   loading 
                                                ? 
                                                    <ButtonSpinner hideText />
                                                : 
                                                    <Button variant="primary" block type="submit" disabled={loading}>
                                                        <ICON_DOWNLOAD />
                                                    </Button>
                                        }
                                    </Col>
                                    <Col md="2" lg="1" className="form-group">
                                        <Button variant="warning" block type="button" onClick={handleReset}>
                                            <ICON_UNDO />
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default ReportForm;
